import React, { useEffect } from 'react';
import './campos-menu-footer.component.scss';
import { Box, Button, FormControlLabel, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { ItemMenusModel, MenusModel } from '../../models/footer.model';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import Accordion from '@mui/material/Accordion';
import AddIcon from '@mui/icons-material/Add';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CamposItemMenuFooterComponent from '../campos-item-menu-footer/campos-item-menu-footer.component';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type CamposMenuProps = {
  setVal: (val: any) => void;
  removeItem: (id?: string) => void;
  menusFooter?: MenusModel;
  index?: number;
}

function CamposMenuFooterComponent(props: CamposMenuProps) {

  const { value: tituloInputText, bind: bindTituloInputText, setValue: setTituloInputText } = useInput(props.menusFooter?.titulo_do_menu);
  const [itensMenus, setItensMenus] = React.useState<any>(props.menusFooter?.item_menu);

  useEffect(() => {
    handleChangeItem();
  }, [itensMenus]);

  // Menus
  const addMenus = () => {
    const items = [...itensMenus];
    const newItem: MenusModel = {
      id: 'item_menu-' + itensMenus.length,
      titulo_do_menu: '',
      item_menu: []
    };

    items.push(newItem);

    setItensMenus(items);
  };

  const handleOnDragEndMenus = (result: any) => {

    const items = Array.from(itensMenus);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setItensMenus(items);
  }

  const handleChageItemMenus = (item: ItemMenusModel) => {

    const items = [...itensMenus];
    const itemEncontrado: ItemMenusModel = items.find(
      a => a.id === item.id
    );
    itemEncontrado.texto = item.texto;
    itemEncontrado.url = item.url;
    itemEncontrado.tipo = item.tipo;
    setItensMenus(items);
  }

  const removerItemMenu = (id?: string) => {
    setItensMenus(
      itensMenus.filter(a =>
        a.id !== id
      )
    );
  }
  // Fim menus

  const handleChangeItem = () => {
    props.setVal({
      titulo_do_menu: tituloInputText,
      item_menu: itensMenus,
      id: props.menusFooter?.id
    });
  };

  return (
    <section className="campos-menu-footer">
      <div className="campo w100">
        <TextField {...bindTituloInputText} label="Título do menu" />
      </div>

      <h2>Item do bloco de menu</h2>
      <DragDropContext onDragEnd={handleOnDragEndMenus}>
        <Droppable droppableId="itens-menus">
          {(provided) => (
            <div className="itens-menus" {...provided.droppableProps} ref={provided.innerRef}>
              {
                itensMenus?.map((item, iMenu) => (
                  <Draggable key={item.id} draggableId={item.id} index={iMenu}>
                    {(provided) => (
                      <Accordion ref={provided.innerRef} {...provided.draggableProps} >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={item.id + '-content'}
                          id={item.id + '-header'}
                          {...provided.dragHandleProps}
                        >
                          <Typography component="span"><OpenWithIcon /> {item.texto}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <CamposItemMenuFooterComponent
                            index={iMenu}
                            itemMenuFooter={item}
                            setVal={(val) => handleChageItemMenus(val)}
                            removeItem={(id) => removerItemMenu(id)}
                          />
                        </AccordionDetails>
                      </Accordion>
                    )}
                  </Draggable>
                ))
              }
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <div className="bts">
        <Button className='bt add' onClick={addMenus}><AddIcon />Adicionar menu</Button>
        <Button className='bt remove' onClick={() => props.removeItem(props.menusFooter?.id)}><DeleteIcon /> Remover menu</Button>
      </div>
    </section>
  );
}

export default CamposMenuFooterComponent;
